import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './components/App';
import 'semantic-ui-less/semantic.less';

const container = document.getElementById('root');
if (!container) {
  throw new Error('Failed to find the root element');
}
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
